<template>
  <section class="bluff-size-selector">
    <h4>
      Step {{ step }}: What bluff size do you want to explore?
      <toggle-help-button
        v-bind:helpAreaVisible="helpAreaVisible"
        v-on:toggleHelp="toggleHelp()"
      />
    </h4>
    <help-section v-if="helpAreaVisible"/>
    <div class="radio">
      <label>
        <input type="radio" v-bind:checked="bluffSize === '1/3'" v-bind:disabled="!authorized" v-on:input="$emit('setBluffSize', '1/3')">
        1/3 pot (needs to work more than 25% of the time in order to be immediately profitable)
      </label>
    </div>
    <div class="radio">
      <label>
        <input type="radio" v-bind:checked="bluffSize === '1/2'" v-bind:disabled="!authorized" v-on:input="$emit('setBluffSize', '1/2')">
        1/2 pot (needs to work more than 33.3% of the time in order to be immediately profitable)
      </label>
    </div>
    <div class="radio">
      <label>
        <input type="radio" v-bind:checked="bluffSize === '2/3'" v-bind:disabled="!authorized" v-on:input="$emit('setBluffSize', '2/3')">
        2/3 pot (needs to work more than 40% of the time in order to be immediately profitable)
      </label>
    </div>
    <div class="radio">
      <label>
        <input type="radio" v-bind:checked="bluffSize === '3/4'" v-bind:disabled="!authorized" v-on:input="$emit('setBluffSize', '3/4')">
        3/4 pot (needs to work more than 42.9% of the time in order to be immediately profitable)
      </label>
    </div>
    <div class="radio">
      <label>
        <input type="radio" v-bind:checked="bluffSize === 'full'" v-bind:disabled="!authorized" v-on:input="$emit('setBluffSize', 'full')">
        Full pot (needs to work more than 50% of the time in order to be immediately profitable)
      </label>
    </div>
    <div class="radio">
      <label>
        <input type="radio" v-bind:checked="bluffSize === '1.5x'" v-bind:disabled="!authorized" v-on:input="$emit('setBluffSize', '1.5x')">
        1.5x pot (needs to work more than 60% of the time in order to be immediately profitable)
      </label>
    </div>
    <div class="radio">
      <label>
        <input type="radio" v-bind:checked="bluffSize === '2x'" v-bind:disabled="!authorized" v-on:input="$emit('setBluffSize', '2x')">
        2x pot (needs to work more than 66.6% of the time in order to be immediately profitable)
      </label>
    </div>
    <div class="radio">
      <label>
        <input
          type="radio"
          v-bind:checked="!['1/3', '1/2', '2/3', '3/4', 'full', '1.5x', '2x'].includes(bluffSize)"
          v-bind:disabled="!authorized"
          v-on:input="$emit('setBluffSize', customBluffSize + 'x')"
        >
        <input
          v-model="customBluffSize"
          type="number"
          v-bind:disabled="!authorized"
          v-on:input="$emit('setBluffSize', customBluffSize + 'x')"
          min="0.1"
          step="0.1"
        >x pot
      </label>
    </div>
  </section>
</template>

<script>
import ToggleHelpButton from '@/components/guided-analyses/help/toggle-help-button';
import HelpSection from '@/components/guided-analyses/should-you-bluff/help/bluff-size-selection';

export default {
  name: 'bluff-size-selector',
  components: {
    'toggle-help-button': ToggleHelpButton,
    'help-section': HelpSection,
  },
  props: ['step', 'bluffSize', 'authorized'],
  data: function () {
    return {
      helpAreaVisible: false,
      customBluffSize: 1,
    };
  },
  watch: {
    bluffSize: function () {
      if (!['1/3', '1/2', '2/3', '3/4', 'full', '1.5x', '2x'].includes(this.bluffSize)) {
        this.customBluffSize = this.bluffSize.split('x')[0];
      }
    },
  },
  methods: {
    toggleHelp: function () {
      this.helpAreaVisible = !this.helpAreaVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import 'src/assets/help-section';

  .bluff-size-selector {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/guided-analyses/should-you-bluff/bluff-size-selector.vue